module.exports = __webpack_public_path__ + "assets/rm-logo.b60dcc4e.svg";